@import "../../../../shared/scss";
:host {
  display: block;

  &:has(phn-nd-dealer-card) {
    margin-block-start: p-px-to-rem(36px);

    .animated {
      display: block;
    }
  }

  phn-nd-dealer-details-drawer {
    margin-block-start: p-px-to-rem(20px);
  }

  phn-nd-menu-item-card {
    & > div {
      margin-block-start: 14px;
    }
  }

  .dealer-card-overlay {
    opacity: 0.3;
  }

  .dealer-card {
    phn-p-tag {
      margin-inline-start: p-px-to-rem(16px);
    }
  }

  .error-message {
    position: relative;
    margin-block-start: p-px-to-rem(32px);
  }

  .animated {
    animation: fadeInFromBottom 0.75s ease-in-out 0s;
  }

  a:has(phn-p-button) {
    display: inline-block;
    position: relative;
    inline-size: 100%;
    text-decoration-line: none;
    margin-block-start: p-px-to-rem(36px);

    phn-p-button {
      inline-size: 100%;
    }
  }
}
